import React from "react"
import { type RouteObject, Navigate } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { lazyPage } from "../lazyPage.tsx"

const PortalCalendarPage = lazyPage(
  () => import("../../../Portal/CalendarPage.tsx")
)
const PortalDocumentsPage = lazyPage(
  () => import("../../../Portal/DocumentsPage.tsx")
)
const PortalHomePage = lazyPage(() => import("../../../Portal/HomePage.tsx"))
const PortalMessagesPage = lazyPage(
  () => import("../../../Portal/MessagesPage.tsx")
)
const PortalPaymentsPage = lazyPage(
  () => import("../../../Portal/PaymentsPage.tsx")
)
const PortalPhotosPage = lazyPage(
  () => import("../../../Portal/PhotosPage.tsx")
)
const PortalProjectWorkspace = lazyPage(
  () => import("../../../Portal/ProjectWorkspace/PortalProjectWorkspace.tsx")
)
const PortalProjectsPage = lazyPage(
  () => import("../../../Portal/ProjectsPage.tsx")
)
const PortalSettingsPage = lazyPage(
  () => import("../../../Portal/SettingsPage.tsx")
)
export const portalRoutes: RouteObject[] = [
  {
    path: "/portal",
    element: <Navigate to={RoutesPaths.portal.home} replace />
  },
  { path: RoutesPaths.portal.home, element: <PortalHomePage /> },
  { path: RoutesPaths.portal.projects, element: <PortalProjectsPage /> },
  {
    path: RoutesPaths.portal.projectPattern,
    element: <PortalProjectWorkspace />
  },
  { path: RoutesPaths.portal.documents, element: <PortalDocumentsPage /> },
  { path: RoutesPaths.portal.photos, element: <PortalPhotosPage /> },
  { path: RoutesPaths.portal.messages, element: <PortalMessagesPage /> },
  { path: RoutesPaths.portal.payments, element: <PortalPaymentsPage /> },
  { path: RoutesPaths.portal.calendar, element: <PortalCalendarPage /> },
  { path: RoutesPaths.portal.settings, element: <PortalSettingsPage /> },
  // Superseded by Settings → Account & security.
  {
    path: RoutesPaths.portal.account,
    element: <Navigate to={RoutesPaths.portal.settings} replace />
  }
]
